<template>
  <Loader v-if="loader" />
  <div class="card">
    <div class="grid p-fluid">
      <div class="col-12 md:col-5 mt-2">
        <span class="p-float-label">
          <Calendar v-model="date_from" dateFormat="dd/mm/yy" :manualInput="false" :showIcon="true"
            inputId="date_from" />
          <label for="date_from">Data Da</label>
        </span>
      </div>
      <div class="col-12 md:col-5 mt-2">
        <span class="p-float-label">
          <Calendar v-model="date_to" dateFormat="dd/mm/yy" :manualInput="false" :showIcon="true" inputId="date_to" />
          <label for="date_to">Data A</label>
        </span>
      </div>
      <div class="col-12 md:col-2 mt-2">
        <Button label="Cerca" @click="getData" icon="pi pi-search" />
      </div>
    </div>

    <div v-if="!loader && invoices.length > 0" class="mt-4">
      <div class="p-inputgroup mb-3">
        <span class="p-inputgroup-addon">
          <i class="pi pi-search"></i>
        </span>
        <InputText v-model="filters.numero" placeholder="Cerca per numero fattura" @input="filterInvoices" />
      </div>

      <div class="flex align-items-center gap-2 mb-3">
        <div class="legend-box text-red"></div>
        <span>Data Fine POD/PDR precedente al {{ moment().subtract(1, 'month').endOf('month').format('DD/MM/YYYY')
          }}</span>
      </div>
      <div class="flex align-items-center gap-2 mb-3">
        <br>
        <h2> Fatture scadute</h2>
      </div>
      <DataTable :value="filteredInvoices" class="p-datatable-sm" responsiveLayout="scroll" :rows="30" :paginator="true"
        :rowsPerPageOptions="[30, 50, 100, 200]" sortField="data_scadenza" :sortOrder="-1">
        <template #row="{ data }">
          <tr :class="{ 'recent-end-date': isRecentEndDate(data) }">
            <slot name="columns" :row="data"></slot>
          </tr>
        </template>
        <Column field="numero" header="Numero Fattura" :sortable="true">
          <template #body="{ data }">
            <template v-if="!data._isTotalRow">
              <a href="#" @click.prevent="openInvoiceDetails(data.numero)" class="font-bold">
                {{ data.numero }}
              </a>
            </template>
          </template>
        </Column>
        <Column field="data_scadenza" header="Data Scadenza" :sortable="true">
          <template #body="{ data }">
            {{ data._isTotalRow ? '' : moment(data.data_scadenza).format('DD/MM/YYYY') }}
          </template>
        </Column>
        <Column header="Data Fine PDP" :sortable="true">
          <template #body="{ data }">
            <template v-if="!data._isTotalRow">
              <span :class="{ 'text-red': isRecentEndDate(data) }">
                {{ data.data_fine_pod ? moment(data.data_fine_pod).format('DD/MM/YYYY') : '' }}
                {{ data.data_fine_pdr ? moment(data.data_fine_pdr).format('DD/MM/YYYY') : '' }}
              </span>
            </template>
          </template>
        </Column>
        <Column field="data_ultimo_preavviso" header="Data Ultimo Preavviso" :sortable="true">
          <template #body="{ data }">
            {{ data._isTotalRow ? '' : (data.data_ultimo_preavviso ? moment(data.data_ultimo_preavviso,
              'YYYY-MM-DD').format('DD/MM/YYYY') : '') }}
          </template>
        </Column>
        <Column header="Cliente" :sortable="true">
          <template #body="{ data }">
            <template v-if="!data._isTotalRow">
              <a href="#" @click.prevent="openClientDetails(data.cliente_id)" class="text-primary hover:underline">
                {{ data.ragsoc || data.nome_completo || ' ' }}
              </a>
            </template>
            <template v-else>Totale</template>
          </template>
        </Column>
        <Column field="agente" header="Agente" :sortable="true" class="col-agente">
          <template #body="{ data }">
            <template v-if="!data._isTotalRow && data.agente">
              <a href="#" @click.prevent="openAgentDetails(data.agente_id)" class="">
                {{ data.agente }}
              </a>
            </template>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante" :sortable="true">
          <template #body="{ data }">
            <template v-if="!data._isTotalRow && data.rappresentante">
              <a href="#" @click.prevent="openRappresentanteDetails(data.rappresentante_id)"
                class="text-primary hover:underline">
                {{ data.rappresentante }}
              </a>
            </template>
          </template>
        </Column>
        <Column field="saldo" header="Saldo" :sortable="true" class="col-saldo">
          <template #body="{ data }">
            <span style="font-weight: bold;"
              :style="data._isTotalRow ? 'background-color: #e8db61; font-weight: bold;' : 'font-weight: bold;'">
              € {{ Number(data.saldo).toFixed(2) }}
            </span>
          </template>
        </Column>
      </DataTable>

      <div class="flex justify-content-end mt-3 p-3 surface-ground border-round">
        <span class="font-bold text-xl">Totale: € {{ Number(totaleSaldo).toLocaleString('it-IT', {
          minimumFractionDigits:
            2,
          maximumFractionDigits: 2
        }) }}</span>
      </div>
      <div class="flex align-items-center gap-2 mb-3">
        <br>
        <h2> Agenti</h2>
      </div>
      <Accordion class="mt-3">
        <AccordionTab v-for="(group, agente) in invoicesByAgent" :key="agente"
          :header="`${agente} - (${group.fatture.length} fatture) - Totale: € ${group.totale.toFixed(2)}`">

          <DataTable :value="group.fatture" class="p-datatable-sm" responsiveLayout="scroll" :rows="10"
            :paginator="true" :rowsPerPageOptions="[10, 20, 30]">

            <Column field="numero" header="Numero Fattura" :sortable="true">
              <template #body="{ data }">
                <a href="#" @click.prevent="openInvoiceDetails(data.numero)" class="text-primary hover:underline">
                  {{ data.numero }}
                </a>
              </template>
            </Column>

            <Column field="ragsoc" header="Cliente" :sortable="true">
              <template #body="{ data }">
                <a href="#" @click.prevent="openClientDetails(data.cliente_id)" class="text-primary hover:underline">
                  {{ data.ragsoc || data.nome_completo || '-' }}
                </a>
              </template>
            </Column>

            <Column field="data_fine_pod" header="Data Fine" :sortable="true">
              <template #body="{ data }">
                <span>
                  {{ data.data_fine_pod ? moment(data.data_fine_pod).format('DD/MM/YYYY') : '' }}
                  {{ data.data_fine_pdr ? moment(data.data_fine_pdr).format('DD/MM/YYYY') : '' }}
                </span>
              </template>
            </Column>

            <!-- IMPORTO (SPOSTATO ALL'ULTIMA POSIZIONE) -->
            <Column field="saldo" header="Importo" :sortable="true">
              <template #body="{ data }">
                <span style="font-weight: bold;">
                  € {{ Number(data.saldo).toFixed(2) }}
                </span>
              </template>

              <!-- TOTALE IMPORTI NEL FOOTER DI QUESTA COLONNA -->
              <template #footer>
                <span style="font-weight: bold;"> €
                  {{ group.fatture.reduce((acc, curr) => acc + Number(curr.saldo), 0).toFixed(2) }}
                </span>
              </template>
            </Column>

            <!-- FOOTER GLOBALE PER IL TOTALE DELLE FATTURE -->
            <template #footer class="fatture">
              <tr>
                <td colspan="3" style="font-weight: bold; text-align: right;"></td>
                <td style="font-weight: bold; text-align: right;">
                  {{ group.fatture.length }}
                </td>
              </tr>
            </template>
          </DataTable>
        </AccordionTab>
      </Accordion>
    </div>

    <div v-if="!loader && invoices.length === 0 && searched" class="mt-4">
      <InlineMessage severity="info">Nessuna fattura trovata per il periodo selezionato</InlineMessage>
    </div>
  </div>
</template>

<script>
import Service from "@/services/ask-management/preavvisi-fatture-clienti-service";
import { ref, computed, getCurrentInstance } from "vue";
import Loader from "@/components/Loader.vue";
import moment from "moment";

export default {
  components: {
    Loader,
  },
  setup() {
    const loader = ref(false);
    const date_from = ref(null);
    const date_to = ref(null);
    const invoices = ref([]);
    const searched = ref(false);
    const filters = ref({
      numero: ''
    });

    const self = getCurrentInstance();
    const service = new Service(self.appContext.config.globalProperties.$http, self.appContext.config.globalProperties.$eventBus);

    const filteredInvoices = computed(() => {
      if (!filters.value.numero) return invoices.value;

      return invoices.value.filter(invoice =>
        invoice.numero.toLowerCase().includes(filters.value.numero.toLowerCase())
      );
    });

    const totaleSaldo = computed(() => {
      return filteredInvoices.value
        .reduce((acc, curr) => acc + Number(curr.saldo), 0)
        .toFixed(2);
    });

    const invoicesByAgent = computed(() => {
      const grouped = filteredInvoices.value.reduce((acc, invoice) => {
        const agente = invoice.agente || 'Non Assegnato';
        if (!acc[agente]) {
          acc[agente] = {
            fatture: [],
            totale: 0
          };
        }
        acc[agente].fatture.push(invoice);
        acc[agente].totale += Number(invoice.saldo);
        return acc;
      }, {});

      return Object.fromEntries(
        Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b))
      );
    });

    const totalRow = computed(() => ({
      _isTotalRow: true,
      saldo: filteredInvoices.value.reduce((acc, curr) => acc + Number(curr.saldo), 0),
      numero: '',
      data_scadenza: '',
      agente: '',
      ragsoc: '',
      nome_completo: ''
    }));

    const getData = async () => {
      if (!date_from.value || !date_to.value) {
        return;
      }

      loader.value = true;
      searched.value = true;
      filters.value.numero = '';

      const dates = {
        data_da: moment(date_from.value).format('YYYY-MM-DD'),
        data_a: moment(date_to.value).format('YYYY-MM-DD')
      };

      try {
        const response = await service.getFattureScaduteOneYear(dates);
        invoices.value = Array.isArray(response.items.data) ? response.items.data : [];
      } catch (error) {
        console.error('Errore nel caricamento delle fatture:', error);
        invoices.value = [];
      } finally {
        loader.value = false;
      }
    };

    const openInvoiceDetails = (numero) => {
      window.open(`/ask/clienti/fatture/${numero}/dettagli`);
    };

    const openClientDetails = (id) => {
      window.open(`/ask/clienti/${id}/dettagli`);
    };

    const openAgentDetails = (id) => {
      window.open(`/ask/agenti/${id}/dettagli`);
    };

    const openRappresentanteDetails = (id) => {
      window.open(`/ask/rappresentanti/${id}/dettagli`);
    };

    const isRecentEndDate = (data) => {
      if (data._isTotalRow) return false;

      const lastDayOfPreviousMonth = moment()
        .subtract(1, 'month')
        .endOf('month');

      const dataFinePDP = data.data_fine_pod || data.data_fine_pdr;
      if (!dataFinePDP) return false;

      const endDate = moment(dataFinePDP);
      return endDate.isBefore(lastDayOfPreviousMonth);
    };

    return {
      loader,
      date_from,
      date_to,
      invoices,
      searched,
      getData,
      moment,
      filters,
      filteredInvoices,
      totaleSaldo,
      invoicesByAgent,
      totalRow,
      openInvoiceDetails,
      openClientDetails,
      openAgentDetails,
      openRappresentanteDetails,
      isRecentEndDate,
    };
  },
};
</script>

<style scoped>
:deep(.p-datatable-tbody > tr > .col-agente) {
  color: blue !important;
  /* O qualunque colore desideri */
}

:deep(.p-datatable-thead > tr > th) {
  background-color: #3388b3;
  color: #ffffff;
  font-size: 1em;
  min-width: 8px !important;
  text-align: flex-start;
  padding: 0.7rem !important;
}

:deep(.p-datatable-tbody > tr:hover) {
  background-color: var(--blue-100);
  font-weight: bold !important;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.5em !important;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: 1rem;
}

:deep(.p-datatable .p-sortable-column.p-highlight) {
  background-color: #3388b3;
  color: #ffffff;
}

:deep(.p-datatable .p-sortable-column .p-sortable-column-icon) {
  color: #ffffff !important;
  margin-left: 0.5rem;
}

:deep(.p-datatable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon) {
  color: #333 !important;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.5em !important;
  border-bottom: 1px solid #eee;
  font-size: 1rem;
}

:deep(.font-bold) {
  font-weight: bold;
  color: #333;
}

:deep(.p-datatable-tbody > tr > td.col-saldo) {
  background-color: #e8db61 !important;
  font-weight: bold;
}

:deep(.p-datatable-tfoot > tr > td) {
  text-align: left;
  padding: 1m 1rem;
  border: 1px solid #e9ecef;
  border-bottom: 0.5p solid #333;
  border-width: 0 0 1px 0;
  font-weight: 600;
  color: #495057;
  border-bottom:1px s+ #333;
  background: #e9db63 !important;
}
:deep(.p-datatable .p-datatable-footer){
  background: #e9db63 !important;
    color: #495057;
    border: 1px solid #e9ecef;
    border-width: 0 0 1px 0;
    padding: 1rem 1rem;
    font-weight: 600;
}

.surface-card {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.surface-border {
  border-color: #dee2e6;
}

.border-round {
  border-radius: 4px;
}

.border-bottom-1 {
  border-bottom: 1px solid #dee2e6;
}

li:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.text-primary {
  color: #3B82F6;
  text-decoration: none;
}

.hover\:underline:hover {
  text-decoration: underline;
}

.recent-end-date {
  background-color: #ffebee !important;
}

.surface-ground {
  background-color: #e9db63 !important;
}

.text-red {
  color: #ff0000 !important;
}

.footer {
  background-color: #e9db63 !important;
  color: #333 !important;
}

.legend-box {
  width: 20px;
  height: 20px;
  background-color: #ffebee;
  border: 1px solid #ff0000;
  border-radius: 4px;
}

.gap-2 {
  gap: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.surface-ground {
  background-color: #f8f9fa;
}

.table thead tr th {
  text-align: left
}

.table tbody tr td {
  white-space: pre-wrap;
  text-align: left
}
</style>
